// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import YDUI from 'vue-ydui';
import 'vue-ydui/dist/ydui.rem.css';
Vue.use(YDUI);
import iView from 'iview';
import 'iview/dist/styles/iview.css';
Vue.use(iView);

import plug from './plugins/index.js'
Vue.use(plug);
Vue.config.productionTip = false
import Vant from 'vant'
import 'vant/lib/index.css';
Vue.use(Vant)

import axios from 'axios'
Vue.prototype.$http=axios
Vue.prototype.imgarr=[
  'personal9.png',
  'personal11.png',
  'personal18.jpg',
  'personal10.png',
  'personal19.jpg',
  'personal20.jpeg',
  'personal21.jpeg',
  'personal22.jpeg',
  'personal24.jpeg',
  'personal23.jpeg',
  'personal25.jpeg',
  '1.jpg',
  '2.jpg',
  '3.jpg',
  '4.jpg',
  '5.jpg',
  '6.jpg',
  '8.jpg',
]
import wxjssdkPlugin from 'vue-wx-jssdk';
// 判断苹果手机
let _url = ''
if (window.__wxjs_is_wkwebview === true) {
  _url = window.location.href.split('#')[0] || window.location.href
} else {
  _url = window.location.href
}
let params = {
    url: _url,
}
const options = {
        
        /*
        *    config可以有两种形式：object或者promise
        *    1、如果是object，则必须包含以下属性：
        *        appId: '', // 必填，公众号的唯一标识
                 timestamp: , // 必填，生成签名的时间戳
                 nonceStr: '', // 必填，生成签名的随机串
                 signature: '',// 必填，签名
        *   
        *    2、如果是promise，则该promise的返回值中必须要能获取到上面格式的object。
        *    下面是一个promise格式的例子，该示例中，从后端的auth/base接口中获取微信配置信息。
        *    该接口返回一个对象，如：
        *    {
        *       data:{
        *           wx:{
        *                appId: 'xxx', 
                         timestamp: xx, 
                         nonceStr: 'xxx', 
                         signature: 'xxx',
        *           }
        *       }
        *    }
        *       
        *    
        * */
    
        config:axios.get('http://admin.aqitai.com/Home/Jssdk/wxposition',{params}),
        
        // 如果config是promise，path需要指定如何从promise返回值中拿到符合格式的object;
        // 如果config是一个object，则无需指定path值
        path:'data.data',
        
        // 声明用到的微信api
        actions:['onMenuShareAppMessage','onMenuShareTimeline']
};
Vue.use(wxjssdkPlugin,options);

/* eslint-disable no-new */
window.Vm = new Vue({
  router,
  Vant,
  render: h => h(App)
}).$mount('#app')
